import { useState, useEffect } from 'react';
import { doc, updateDoc } from "firebase/firestore";
import { db } from '../../firebase';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField,
    Typography,
    useMediaQuery,
    Select
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import moment from 'moment'
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
// ===========================|| FIREBASE - REGISTER ||=========================== //

const FirebaseRegister = ({ auth }) => {

    let User = auth?.User;
    var days = 4749;
    var newdate = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
    const d = new Date(newdate);
    const formatdate = moment(d).format('YYYY-MM-DD');

    const [DOBS, setDOBS] = useState(User?.dobs == undefined ? formatdate : User?.dobs)



    const theme = useTheme();
    const scriptedRef = useScriptRef();


    const UpdateAndReloadStudent = async (values) => {
        const Age = moment(values?.dob).format('YYYY-MM-DD');
        console.log(User.uid)
        const UpdateUser = doc(db, "Users", User.uid);
        await updateDoc(UpdateUser, {
            name: values?.name,
            gender: values?.gender,
            religion: values?.religion,
            dob: Age,
            ProfileReview: true
        });
    }



    return (
        <>
            <Grid container direction="column" justifyContent="center" spacing={2}>
                <Grid item xs={12} container alignItems="center" justifyContent="center">
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1">Complete Your Profile</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Formik
                initialValues={{
                    // email: User?.email,
                    name: User?.name,
                    submit: null,
                    gender: User?.gender || 0,
                    religion: User?.religion || 0,
                    // dobs: User?.dob,
                    password: '1232424'
                }}
                validationSchema={Yup.object().shape({
                    // email: Yup.string().email('Must be a valid email').max(100).required('Email is required'),
                    name: Yup.string().max(100).required('name is required'),
                    gender: Yup.string().max(20).required('Select Gender'),
                    religion: Yup.string().max(20).required('Select Religion'),
                })}
                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {

                    console.log(values)
                    if (values?.name?.length > 0 && DOBS?.length > 0) {
                        UpdateAndReloadStudent(values)
                    }
                    try {
                        if (scriptedRef.current) {
                            setStatus({ success: true });
                            setSubmitting(false);


                        }
                    } catch (err) {
                        console.error(err);
                        if (scriptedRef.current) {
                            setStatus({ success: false });
                            setErrors({ submit: err.message });
                            setSubmitting(false);

                        }
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <form noValidate onSubmit={handleSubmit} >

                        <InputLabel htmlFor="outlined-adornment-email-register" style={{ marginLeft: 10 }}>Full Name</InputLabel>
                        <FormControl fullWidth error={Boolean(touched.name && errors.name)} sx={{ ...theme.typography.customInput }}>

                            <OutlinedInput
                                id="outlined-adornment-name-register"
                                type="name"
                                value={values.name}
                                name="name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                                style={{ width: 300 }}
                            />
                            {touched.name && errors.name && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.name}
                                </FormHelperText>
                            )}
                        </FormControl>

                        {/* <InputLabel htmlFor="outlined-adornment-email-register" style={{ marginLeft: 10 }}>Email Address</InputLabel> */}
                        {/* <FormControl fullWidth error={Boolean(touched.email && errors.email)} sx={{ ...theme.typography.customInput }}>

                            <OutlinedInput
                                id="outlined-adornment-email-register"
                                type="email"
                                value={values.email}
                                disabled={true}
                                name="email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                            />
                            {touched.email && errors.email && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.email}
                                </FormHelperText>
                            )}
                        </FormControl> */}

                        <InputLabel htmlFor="outlined-adornment-email-register" style={{ marginLeft: 10 }}>Date Of Birth </InputLabel>

                        <FormControl fullWidth sx={{ ...theme.typography.customInput }}>

                            {/* <LocalizationProvider dateAdapter={DateAdapter}>
                                <DatePicker
                                    maxDate={moment(formatdate)}
                                    value={values.dobs}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    inputProps={{}}
                                    renderInput={(params) => <TextField {...params} color="error"
                                    />
                                    }
                                    style={{ border: 0 }}
                                />
                            </LocalizationProvider> */}
                            <LocalizationProvider dateAdapter={DateAdapter}>
                                <DatePicker
                                    maxDate={moment(formatdate)}
                                    value={DOBS}
                                    onBlur={handleBlur}
                                    onChange={(newValue) => {
                                        setDOBS(newValue);
                                    }}
                                    inputProps={{}}
                                    renderInput={(params) => <TextField {...params} color="error"
                                    />
                                    }
                                    style={{ border: 0 }}
                                />
                            </LocalizationProvider>
                            {touched.dobs && errors.dobs && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.dobs}
                                </FormHelperText>
                            )}
                        </FormControl>


                        <InputLabel htmlFor="outlined-adornment-email-register" style={{ marginLeft: 10 }}>Select Gender</InputLabel>

                        <FormControl fullWidth error={Boolean(touched.gender && errors.gender)} sx={{ ...theme.typography.customInput }}>

                            <Select
                                labelId="demo-simple-select-label"
                                id="outlined-adornment-email-register"
                                name="gender"
                                value={values.gender}
                                onChange={handleChange}
                                onBlur={handleBlur}

                            >
                                <MenuItem value={"0"}>--Select Gender--</MenuItem>
                                <MenuItem value={"male"}>Male</MenuItem>
                                <MenuItem value={"female"}>Female</MenuItem>

                            </Select>
                            {touched.gender && errors.gender && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.gender}
                                </FormHelperText>
                            )}
                        </FormControl>

                        <InputLabel htmlFor="outlined-adornment-email-register" style={{ marginLeft: 10 }}>Select Religion</InputLabel>
                        <FormControl fullWidth error={Boolean(touched.religion && errors.religion)} sx={{ ...theme.typography.customInput }}>

                            <Select
                                labelId="demo-simple-select-label"
                                id="outlined-adornment-email-register"
                                name="religion"
                                value={values.religion}
                                onChange={handleChange}
                                onBlur={handleBlur}

                            >
                                <MenuItem value={"0"}>--Select Religion--</MenuItem>

                                <MenuItem value={"Muslim"}>Muslim</MenuItem>
                                <MenuItem value={"Non-Muslim"}>Non-Muslim</MenuItem>

                            </Select>
                            {touched.religion && errors.religion && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.religion}
                                </FormHelperText>
                            )}
                        </FormControl>

                        <center><p>All fields are required </p></center>
                        <Box sx={{ mt: 2 }}>
                            <AnimateButton>
                                <Button
                                    disableElevation
                                    disabled={isSubmitting}
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    style={{ backgroundColor: 'red' }}
                                >
                                    Continue
                                </Button>
                            </AnimateButton>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default FirebaseRegister;